import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card_container" }
const _hoisted_2 = { class: "title_text" }
const _hoisted_3 = { class: "title_text" }
const _hoisted_4 = { class: "right_text" }
const _hoisted_5 = { class: "right_text" }

import { ref } from 'vue';
import InfoPoup from './infoPoup.vue';
import DepositPopup from './depositPopup.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'promotionCard',
  props: {
    cardData: {
        type: Object,
        required: true
    },
    isActivityEnable: {
        type: Boolean,
        default: false
    },
    dayName: {
        type: String,
    }
},
  setup(__props) {

const infoPopupRef = ref()
const depositpopupRef = ref()
const props = __props
const handleDeposit = () => {
    if (props.isActivityEnable) {
        depositpopupRef.value.open(props.cardData)
    } else {
        infoPopupRef.value.open(props.dayName)
    }
}

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_row, { class: "card_data" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "12" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createTextVNode(_toDisplayString(_ctx.$t('common.deposite')) + " ", 1),
                _createElementVNode("span", null, [
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "currencyIcon" }, "R$", -1)),
                  _createTextVNode(" " + _toDisplayString(Number(props.cardData.recharge)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createTextVNode(_toDisplayString(_ctx.$t('offers.win')) + " ", 1),
                _createElementVNode("span", null, [
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "currencyIcon" }, "R$", -1)),
                  _createTextVNode(" " + _toDisplayString(Number(props.cardData.reward)), 1)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "12",
            class: "right_cell"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", null, _toDisplayString(Number(props.cardData.recharge) +
                    Number(props.cardData.reward)), 1)
              ]),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('offers.totaling')) + "(R$)", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "6",
            offset: "18",
            class: "deposit_btn"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_button, {
                size: "small",
                onClick: handleDeposit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.deposite')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "24",
            class: "bottom_text"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('offers.demanding')) + " R$ " + _toDisplayString(Number(props.cardData.turnover)) + " " + _toDisplayString(_ctx.$t('offers.rollover')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(InfoPoup, {
      ref_key: "infoPopupRef",
      ref: infoPopupRef
    }, null, 512),
    _createVNode(DepositPopup, {
      ref_key: "depositpopupRef",
      ref: depositpopupRef
    }, null, 512)
  ], 64))
}
}

})